import { useEffect, useState, useContext } from "react";
import Repo from "../../Utility/Repo";
import { TokenContext } from "../../Components/TokenContext";
import Loader from "../../Components/Loader";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { Link } from "react-router-dom";

function StatistichePage(props) {
  const apiToken = useContext(TokenContext);
  const [loading, setLoading] = useState(true);

  // --- Payments stats ---
  const [statistiche, setStatistiche] = useState(null);

  // --- Subscriptions per bando ---
  const [iscrizioniPerBando, setIscrizioniPerBando] = useState([]);

  // --- Payment list for per-bando aggregation ---
  const [pagamentiPerBando, setPagamentiPerBando] = useState([]);

  const [error, setError] = useState(null);

  useEffect(() => {
    if (!apiToken) return;

    setLoading(true);

    const p1 = Repo.getTotali(apiToken)
      .then((r) => {
        if (r.status === 200) setStatistiche(r.data);
      })
      .catch(() => {});

    const p2 = Repo.getSubscriptionNewList(apiToken)
      .then((r) => {
        if (r.status === 200) setIscrizioniPerBando(r.data || []);
      })
      .catch(() => {});

    const p3 = Repo.getListPaymentFilterOperator(apiToken, {})
      .then((r) => {
        if (r.status === 200) {
          const raw = r.data || [];
          // Aggregate by annuncio name
          const map = {};
          raw.forEach((p) => {
            const key = p.annuncio || p.nomeBando || p.announcement || "N/D";
            if (!map[key]) map[key] = { totale: 0, count: 0, pagati: 0, importoPagato: 0 };
            map[key].totale += 1;
            const importo = parseFloat(p.importoTotale || 0);
            const isPagato =
              p.statoPagamento === "Pagato" ||
              p.statoPagamento === "PAID" ||
              p.stato === "Pagato" ||
              p.stato === "PAID";
            if (isPagato) {
              map[key].pagati += 1;
              map[key].importoPagato += importo;
            }
            map[key].count += 1;
          });
          const rows = Object.entries(map).map(([nome, v]) => ({ nome, ...v }));
          setPagamentiPerBando(rows);
        }
      })
      .catch(() => {});

    Promise.all([p1, p2, p3]).finally(() => setLoading(false));
  }, [apiToken]);

  const totaleIscritti = iscrizioniPerBando.reduce(
    (acc, i) => acc + (i.subscriptionNew || 0),
    0
  );

  const totaleImportoPagato = pagamentiPerBando.reduce(
    (acc, p) => acc + (p.importoPagato || 0),
    0
  );

  const totalePagamenti = pagamentiPerBando.reduce(
    (acc, p) => acc + (p.totale || 0),
    0
  );

  return (
    <>
      <h1>Statistiche</h1>
      <div className="clearfix col-lg-12 py-lg-2 mb-3">
        <p>
          Panoramica dei pagamenti effettuati e delle iscrizioni ai bandi
          attivi.
        </p>
      </div>

      {loading && <Loader />}

      {!loading && (
        <>
          {/* ── KPI cards ── */}
          <div className="row mb-4">
            <div className="col-md-3 mb-3">
              <div className="card shadow-sm h-100 border-0">
                <div className="card-body text-center">
                  <svg className="icon icon-primary mb-2" style={{ width: 40, height: 40 }}>
                    <use href={`${iconSprite}#it-pa`} />
                  </svg>
                  <h5 className="card-title">Bandi attivi</h5>
                  <span
                    className="badge badge-pill badge-primary"
                    style={{ fontSize: "1.4em" }}
                  >
                    {iscrizioniPerBando.length}
                  </span>
                </div>
              </div>
            </div>

            <div className="col-md-3 mb-3">
              <div className="card shadow-sm h-100 border-0">
                <div className="card-body text-center">
                  <svg className="icon icon-primary mb-2" style={{ width: 40, height: 40 }}>
                    <use href={`${iconSprite}#it-user`} />
                  </svg>
                  <h5 className="card-title">Nuove iscrizioni</h5>
                  <span
                    className="badge badge-pill"
                    style={{ fontSize: "1.4em", backgroundColor: "#2e58a6", color: "#fff" }}
                  >
                    {totaleIscritti}
                  </span>
                </div>
              </div>
            </div>

            <div className="col-md-3 mb-3">
              <div className="card shadow-sm h-100 border-0">
                <div className="card-body text-center">
                  <svg className="icon icon-success mb-2" style={{ width: 40, height: 40 }}>
                    <use href={`${iconSprite}#it-check-circle`} />
                  </svg>
                  <h5 className="card-title">Pagamenti totali</h5>
                  <span
                    className="badge badge-pill badge-success"
                    style={{ fontSize: "1.4em" }}
                  >
                    {totalePagamenti}
                  </span>
                </div>
              </div>
            </div>

            <div className="col-md-3 mb-3">
              <div className="card shadow-sm h-100 border-0">
                <div className="card-body text-center">
                  <svg className="icon mb-2" style={{ width: 40, height: 40, color: "#1fa84f" }}>
                    <use href={`${iconSprite}#it-card`} />
                  </svg>
                  <h5 className="card-title">Incassato totale</h5>
                  <span
                    className="badge badge-pill"
                    style={{ fontSize: "1.2em", backgroundColor: "#1fa84f", color: "#fff" }}
                  >
                    {totaleImportoPagato.toLocaleString("it-IT", {
                      style: "currency",
                      currency: "EUR",
                    })}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            {/* ── Iscrizioni per bando ── */}
            <div className="col-lg-6 mb-4">
              <div className="card shadow-sm h-100 border-0">
                <div className="card-header bg-white">
                  <h5 className="mb-0">
                    <svg className="icon icon-primary mr-2">
                      <use href={`${iconSprite}#it-list`} />
                    </svg>
                    Iscrizioni per intervento
                  </h5>
                </div>
                <div className="card-body p-0">
                  {iscrizioniPerBando.length === 0 ? (
                    <div className="alert alert-info m-3">
                      Nessuna iscrizione disponibile.
                    </div>
                  ) : (
                    <table className="table table-hover mb-0">
                      <thead className="thead-light">
                        <tr>
                          <th>Intervento</th>
                          <th>Categoria</th>
                          <th className="text-center">Nuove iscrizioni</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {iscrizioniPerBando.map((item, i) => (
                          <tr key={i}>
                            <td>{item.annuncementName || "—"}</td>
                            <td>{item.serviceName || "—"}</td>
                            <td className="text-center">
                              {item.subscriptionNew > 0 ? (
                                <span
                                  className="badge badge-pill p-2"
                                  style={{ backgroundColor: "#2e58a6", color: "#fff" }}
                                >
                                  {item.subscriptionNew}
                                </span>
                              ) : (
                                <span className="text-muted">0</span>
                              )}
                            </td>
                            <td className="text-right">
                              <Link
                                to={
                                  "/lista_interventi/dettaglio_intervento?id=" +
                                  item.annuncementId
                                }
                              >
                                <button
                                  className="btn btn-outline-primary btn-sm"
                                  title="Dettaglio intervento"
                                >
                                  <svg className="icon icon-primary icon-sm">
                                    <use href={`${iconSprite}#it-search`} />
                                  </svg>
                                </button>
                              </Link>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            </div>

            {/* ── Pagamenti per bando ── */}
            <div className="col-lg-6 mb-4">
              <div className="card shadow-sm h-100 border-0">
                <div className="card-header bg-white">
                  <h5 className="mb-0">
                    <svg className="icon icon-primary mr-2">
                      <use href={`${iconSprite}#it-card`} />
                    </svg>
                    Pagamenti per intervento
                  </h5>
                </div>
                <div className="card-body p-0">
                  {pagamentiPerBando.length === 0 ? (
                    <div className="alert alert-info m-3">
                      Nessun pagamento disponibile.
                    </div>
                  ) : (
                    <table className="table table-hover mb-0">
                      <thead className="thead-light">
                        <tr>
                          <th>Intervento</th>
                          <th className="text-center">Totale</th>
                          <th className="text-center">Pagati</th>
                          <th className="text-right">Incassato</th>
                        </tr>
                      </thead>
                      <tbody>
                        {pagamentiPerBando.map((p, i) => (
                          <tr key={i}>
                            <td>{p.nome}</td>
                            <td className="text-center">
                              <span className="badge badge-secondary">
                                {p.totale}
                              </span>
                            </td>
                            <td className="text-center">
                              <span
                                className="badge badge-success"
                              >
                                {p.pagati}
                              </span>
                            </td>
                            <td className="text-right">
                              <strong>
                                {p.importoPagato.toLocaleString("it-IT", {
                                  style: "currency",
                                  currency: "EUR",
                                })}
                              </strong>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* ── Totali finanziari da API ── */}
          {statistiche && Object.keys(statistiche).length > 0 && (
            <div className="row mt-2">
              <div className="col-12">
                <div className="callout">
                  <div className="callout-inner">
                    <div className="callout-title">
                      <svg className="icon">
                        <use href={`${iconSprite}#it-info-circle`} />
                      </svg>
                      <span className="text">Riepilogo finanziario</span>
                    </div>
                    <div className="row">
                      {Object.entries(statistiche).map(([nome, valore]) => (
                        <div key={nome} className="col-md-3 col-6 mb-3">
                          <div className="card border-0 bg-light text-center py-3">
                            <div className="text-muted small mb-1">{nome}</div>
                            <strong className="text-primary" style={{ fontSize: "1.2em" }}>
                              {valore != null ? Number(valore).toFixed(2) + " €" : "—"}
                            </strong>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
}

export default StatistichePage;
